export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "When testing an application or software product in an operating state, we use this.",
    "description": "Dynamic application security testing (DAST)."
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "This technique involves the splitting up and storing of encrypted information across different cloud storage services. It is virtually impossible to reconstruct without the proper keys.",
    "description": "Bit splitting."
  },
  {
    "id": 3,
    "topic_id": 1,
    "title": "This international law introduces significant changes for data processors and controllers, including the concept of consent, transfers abroad, the right to be forgotten, establishment of the role of \u201cdata protection officer\u201d access requests, home state regulation, and increased sanctions.",
    "description": "EU General Data Protection (EGDP) Regulation 2012."
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "This service replicates data across geographic areas.",
    "description": "Content delivery network (CDN)."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "These mechanisms act to restrict a list of possible actions down to allowed or permitted actions.",
    "description": "Control."
  },
  {
    "id": 6,
    "topic_id": 1,
    "title": "The process of utilizing cloud management tools to ensure that cloud computing services are working properly through the use of software and technologies designed for operation and monitoring of cloud applications, data, and services.",
    "description": "Cloud management."
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "This framework is designed to enable cooperation between cloud consumers and provider in demonstrating appropriate risk management.",
    "description": "Security Alliance\u2019s Cloud Controls Matrix (CCM)."
  },
  {
    "id": 8,
    "topic_id": 1,
    "title": "Routines, standards, protocols, and tools for connecting software applications to web-based services, applications, or tools.",
    "description": "Application programming interface (API)."
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "These devices are used to securely store and manage encryption keys. The keys can be used for such purposes as securing data transmissions and protecting log files.",
    "description": "Hardware security module (HSM)."
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "This international standard was developed to develop and maintain an information security management system (ISMS), which is composed of interrelated elements that organizations use to manage information security risks and to support the CIA triad.",
    "description": "ISO/IEC 27001:2013."
  },
  {
    "id": 11,
    "topic_id": 1,
    "title": "One type of cloud storage wherein cloud and enterprise storage both reside inside the enterprise behind the firewall.",
    "description": "Private cloud storage."
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "This term describes data center networks logically divided into smaller, isolated networks that share the physical networking gear but operate separately without visibility into other logical networks.",
    "description": "Multitenancy."
  },
  {
    "id": 13,
    "topic_id": 1,
    "title": "In 1996, this US law was passed to provide national standards for electronic medical transactions and national identifiers for providers, health plans, and employers.",
    "description": "Health Insurance Portability and Accountability Act (HIPAA)."
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "This activity revolves around the generation, storage, distribution, deletion, archiving, and application of keys in accordance with security policies.",
    "description": "Key management."
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "This service offers customers the ability to rent hardware, storage, and network capacity over the Internet from a cloud service provider.",
    "description": "Infrastructure as a service."
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "This controls the entire infrastructure. As such, part of it will be exposed to customers independent of their location, thus making it a highly valued asset to be protected.",
    "description": "Management plane."
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "This theoretical type of encryption or encryption technique allows encrypted data to be processed without first decrypting. It is extremely slow due to the intense mathematical calculations and as a result is not practical at this time.",
    "description": "Homomorphic encryption."
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "This body of rights, obligations, and remedies describes the remedies and reliefs for anyone suffering harm as a result of the wrongful act or acts of another.",
    "description": "Tort law."
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "The framework of items that contains all of the components of application security best practices that are catalogued and leveraged by the enterprise.",
    "description": "Organizational Normative Framework (ONF)."
  },
  {
    "id": 20,
    "topic_id": 1,
    "title": "This type of cloud infrastructure is designed for use by a specific community of organizations with shared concerns (e.g., mission, security requirements, policy, and/or compliance considerations).",
    "description": "Community cloud."
  },
  {
    "id": 21,
    "topic_id": 1,
    "title": "This type of filter, appliance, or server plug-in is used to apply a set of rules to HTTP conversations in real time as a way of protecting from common attacks such as cross-site scripting or SQL injection.",
    "description": "A web application firewall (WAP)."
  },
  {
    "id": 22,
    "topic_id": 1,
    "title": "This special mathematical code allows encryption hardware and/or software to encrypt and decipher encrypted messages.",
    "description": "Encryption key."
  },
  {
    "id": 23,
    "topic_id": 1,
    "title": "This standard, which introduces definitions, concepts, principles, and processes involved in application security, provides an overview of application security.",
    "description": "ISO/IEC 27034-1."
  },
  {
    "id": 24,
    "topic_id": 1,
    "title": "This term identifies an arrangement among multiple enterprises that allows subscribers or users to use the same identification data or credentials and to obtain access to the networks and all associated resources of the enterprises participating in the arrangement.",
    "description": "Federated identity management."
  },
  {
    "id": 25,
    "topic_id": 1,
    "title": "A security technology used for the monitoring and analysis of database activity. It operates independently of the database management system (DBMS) and is independent of any native DMS-resident auditing or native logs such as trace or transaction logs.",
    "description": "Database activity monitoring (DAM)."
  },
  {
    "id": 26,
    "topic_id": 1,
    "title": "This term is used in describing capabilities of a network to differentiate and provide differing qualities of service to various types of network traffic over different communication technologies such as ATM, Ethernet, and IP routed networks.",
    "description": "Quality of service (QoS)."
  },
  {
    "id": 27,
    "topic_id": 1,
    "title": "This type of cloud storage involves using both public cloud and enterprise private cloud storage.",
    "description": "Hybrid cloud storage."
  },
  {
    "id": 28,
    "topic_id": 1,
    "title": "This particular SOC report on controls at service organizations is relevant to the user entities\u2019 internal controls over financial reporting.",
    "description": "Service Organizations Control 1 (SOC 1)."
  },
  {
    "id": 29,
    "topic_id": 1,
    "title": "When the number of users connected to a system or systems exceeds the number that can be fully supported simultaneously.",
    "description": "Oversubscription."
  },
  {
    "id": 30,
    "topic_id": 1,
    "title": "A set of processes and structures used to effectively manage all risks to an enterprise.",
    "description": "Enterprise risk management."
  },
  {
    "id": 31,
    "topic_id": 1,
    "title": "This partly addresses the management of network components, the objective of which is to provide a control plane that can manage network traffic via an abstraction layer as opposed to direct device management.",
    "description": "Software-defined networking (SDN)."
  },
  {
    "id": 32,
    "topic_id": 1,
    "title": "The service provider that offers storage, computing, and/or software applications that are available across the Internet from anywhere, anytime.",
    "description": "Cloud provider."
  },
  {
    "id": 33,
    "topic_id": 1,
    "title": "This networking model uses a layered approach with physical switches at the top layer and logical separation occurring at the hypervisor level.",
    "description": "Traditional networking model."
  },
  {
    "id": 34,
    "topic_id": 1,
    "title": "Using two or more storage servers in tandem in order to increase performance, capacity, and/or reliability. This technique also distributes the workloads and ensures access to all files from all servers at all times regardless of physical location of data.",
    "description": "Storage clusters."
  },
  {
    "id": 35,
    "topic_id": 1,
    "title": "The testing of load and performance capabilities on the services and applications provided by cloud computing providers is designed to ensure optimal performance and scalability under varying conditions. What is it called?",
    "description": "Cloud testing."
  },
  {
    "id": 36,
    "topic_id": 1,
    "title": "This law was passed as a means to protect shareholders as well as the general public from accounting errors and fraudulent practices.",
    "description": "Sarbanes\u2013Oxley Act (SOX)."
  },
  {
    "id": 37,
    "topic_id": 1,
    "title": "This type of assessment typically employs methods, principles, or rules for assessing risk based on nonnumerical values such as high, medium, and low.",
    "description": "Qualitative assessment."
  },
  {
    "id": 38,
    "topic_id": 1,
    "title": "What is an organization that buys hosting services with the intent of reselling them to its own customers?",
    "description": "Cloud computing reseller."
  },
  {
    "id": 39,
    "topic_id": 1,
    "title": "This term describes granting the right of access to a program, process, or user.",
    "description": "Authorization."
  },
  {
    "id": 40,
    "topic_id": 1,
    "title": "This type of storage is broken down into objects, which include additional metadata (content type, redundancy required, creation dates, etc.). They are accessed through APIs and often a web interface.",
    "description": "Object storage."
  },
  {
    "id": 41,
    "topic_id": 1,
    "title": "This term describes a kind of computing model that relies on sharing compute resources in a remote location as opposed to the use of local servers or personal devices to handle computing processes.",
    "description": "Cloud computing."
  },
  {
    "id": 42,
    "topic_id": 1,
    "title": "This term refers to the ability of individuals to store their data over the Internet using a storage service provider as opposed to the data being stored locally on a disk or tape backup.",
    "description": "Cloud backup solutions."
  },
  {
    "id": 43,
    "topic_id": 1,
    "title": "This term describes what happens when a customer is unable to leave, migrate, or transfer to an alternate cloud provider due to technical or nontechnical constraints.",
    "description": "Vendor lock-in."
  },
  {
    "id": 44,
    "topic_id": 1,
    "title": "This 1988 act relates to the regulation with respect to the handling of personal information about individuals, including the collection, use, storage, and disclosure of personal information as well as access to and the ability to correct misinformation.",
    "description": "Australian Privacy Act 1988."
  },
  {
    "id": 45,
    "topic_id": 1,
    "title": "A model for examining the nature and severity of threats whose name is derived from and based on the following six categories: Spoofing identity, Tampering with data, Repudiation, Information disclosure, Denial of service, and Elevation of privilege.",
    "description": "STRIDE threat model."
  },
  {
    "id": 46,
    "topic_id": 1,
    "title": "This term refers to the security and encryption designed to prevent unauthorized copying and limitation of distribution to those who have purchased the rights.",
    "description": "Digital Rights Management (DRM)."
  },
  {
    "id": 47,
    "topic_id": 1,
    "title": "This term describes software applications that help the business in solving enterprise problems.",
    "description": "Enterprise application."
  },
  {
    "id": 48,
    "topic_id": 1,
    "title": "Who determines under what circumstances a private cloud meets the policies and needs of an organization\u2019s strategic goals and contractual requirements (from a technical perspective)?",
    "description": "Cloud architect."
  },
  {
    "id": 49,
    "topic_id": 1,
    "title": "This term refers to the accreditation used to distinguish between secure and well-established crypto modules produced in the private sector. It stands as a certification for those producers who need them to be used in regulated industries that typically collect, store, transfer, and share data that is deemed to be sensitive in nature but not classified.",
    "description": "FIPS 140-2."
  },
  {
    "id": 50,
    "topic_id": 1,
    "title": "This form of cloud storage applies to storing mobile device data in the cloud while providing access to the stored data from anywhere.",
    "description": "Mobile cloud storage."
  },
  {
    "id": 51,
    "topic_id": 1,
    "title": "This security discipline is about enabling the right individual\u2019s access to the right resources at the right time for the right reasons.",
    "description": "Identity and access management (IAM)."
  },
  {
    "id": 52,
    "topic_id": 1,
    "title": "This method of computer access control uses authentication factors from at least two of three categories of knowledge factors; what the user knows, what the user has, and/or what the user is.",
    "description": "Multifactor authentication."
  },
  {
    "id": 53,
    "topic_id": 1,
    "title": "This cloud model provides a complete infrastructure and allows companies to install software on provisioned servers and control the configuration of all devices.",
    "description": "Infrastructure as a service (IaaS)."
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "This important activity determines the impact of losing support of any particular resource to an organization, helps establish the escalation of that loss over time, identifies the minimum resources needed to recover the support or asset, and prioritizes the recovery processes and supporting systems.",
    "description": "Business impact analysis (BIA)."
  },
  {
    "id": 55,
    "topic_id": 1,
    "title": "This model hosts software by a cloud vendor or service provider and is available to customers over network resources.",
    "description": "Software as a service."
  },
  {
    "id": 56,
    "topic_id": 1,
    "title": "This is a set of technologies aimed at analyzing source code, byte code, and binaries for coding and design conditions that show indications of security vulnerabilities.",
    "description": "Static application security testing (SAST)."
  },
  {
    "id": 57,
    "topic_id": 1,
    "title": "This standard is designed for the exchange of authentication and authorization data between security domains.",
    "description": "Security Assertion Markup Language (SAML)."
  },
  {
    "id": 58,
    "topic_id": 1,
    "title": "This US law was enacted as a way of controlling the ways that financial institutions and insurance companies safeguard the private information of individuals with whom they conduct business.",
    "description": "Gramm-Leach-Bliley Act (GLBA)."
  },
  {
    "id": 59,
    "topic_id": 1,
    "title": "This type of risk assessment uses a set of methods, principles, and rules based on the use of numbers. It also supports cost-benefit analyses of alternative risk responses.",
    "description": "Quantitative risk assessment."
  },
  {
    "id": 60,
    "topic_id": 1,
    "title": "This type of networking model for cloud deployments is designed with standard perimeter protection mechanisms, with the underlying storage and IP networks converged to maximize benefits for the cloud workload.",
    "description": "Converged networking model."
  },
  {
    "id": 61,
    "topic_id": 1,
    "title": "This configuration is used to isolate network components, such as web servers, that are accessible by untrusted networks and therefore external attacks.",
    "description": "Demilitarized zone (DMZ)."
  },
  {
    "id": 62,
    "topic_id": 1,
    "title": "These are often used as decoys and consist of a computer, data, or a network site that appear to be part of a legitimate network but are in fact bogus. They are isolated and monitored for activity in the hopes of discovering information about possible malicious attacks or attackers.",
    "description": "Honeypots."
  },
  {
    "id": 63,
    "topic_id": 1,
    "title": "The database used for mapping DNS domain names to various types of data such as IP addresses. This hierarchical database permits us to use human-readable or \u201cfriendly\u201d names, such as www.isc2.org, to locate computers and resources associated with that name without having to know the IP address associated with the object.",
    "description": "Domain Name System (DNS)."
  },
  {
    "id": 64,
    "topic_id": 1,
    "title": "The use of many smaller disks, as opposed to a single large one, that when configured allows the drives to be placed in a group, thereby increasing performance and redundancy and reducing the chances of data loss.",
    "description": "Redundant array of independent disks (RAID)."
  },
  {
    "id": 65,
    "topic_id": 1,
    "title": "This term refers to the idea of leveraging cloud computing as a way of creating offsite storage with little or no hardware requirements for the enterprise.",
    "description": "Online backup."
  },
  {
    "id": 66,
    "topic_id": 1,
    "title": "This particular cloud infrastructure is composed of two or more distinct and different cloud infrastructures (private, community, or public) and still remains a unique entity while bound together by standardized or proprietary technologies that enables data and application portability (e.g., cloud bursting, for load balancing between clouds).",
    "description": "Hybrid cloud."
  },
  {
    "id": 67,
    "topic_id": 1,
    "title": "This report on Controls at a Service Organization is focused on the security, availability, processing integrity, confidentiality, and privacy of the organization and its controls.",
    "description": "Service Organization Control 2 (SOC 2)."
  },
  {
    "id": 68,
    "topic_id": 1,
    "title": "This term refers to processes involved where electronic data is sought, located, secured, and searched for with the intent of using it as evidence in criminal or civil proceedings.",
    "description": "eDiscovery."
  },
  {
    "id": 69,
    "topic_id": 1,
    "title": "This form of cloud storage involves storing an individual\u2019s data in the cloud, allowing that person access from anywhere, anytime.",
    "description": "Personal cloud storage."
  },
  {
    "id": 70,
    "topic_id": 1,
    "title": "The purpose of this document is to ensure appropriate security requirements and controls are applied to all US federal government information and information management systems.",
    "description": "NIST 800-53."
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "This term refers to a type of testing environment where untested code changes and experimentation from the production can occur safely in isolation. It is usually used in the context of software development, including web development and revision control.",
    "description": "Sandbox."
  },
  {
    "id": 72,
    "topic_id": 1,
    "title": "These technologies describe what enables cloud comping to be a real and highly scalable service offering due to decreased costs and resource sharing across multiple tenants and environments.",
    "description": "Virtualization technologies."
  },
  {
    "id": 73,
    "topic_id": 1,
    "title": "This protocol allows separate channels to carry presentation data, serial device communication, licensing, and highly encrypted data (keyboard and mouse activity).",
    "description": "Remote Desktop Protocol (RDP)."
  },
  {
    "id": 74,
    "topic_id": 1,
    "title": "This activity is designed to prevent unauthorized data exfiltration.",
    "description": "Egress monitoring (often referred to as \u201cDLP,\u201d a marketing term used to refer to \u201cdata loss prevention\u201d or \u201cdata leak protection,\u201d or similar variants)."
  },
  {
    "id": 75,
    "topic_id": 1,
    "title": "The overt or secret writing technique using a bidirectional mathematical algorithm that transforms plaintext into unintelligible ciphertext.",
    "description": "Encryption."
  },
  {
    "id": 76,
    "topic_id": 1,
    "title": "This form of cloud storage involves the enterprise and storage service being separate, with data stored outside the confines of the enterprise environment.",
    "description": "Public cloud storage."
  },
  {
    "id": 77,
    "topic_id": 1,
    "title": "This involves making a structurally similar yet inauthentic copy of an organization\u2019s data that is then used strictly for purposes of software testing and user training",
    "description": "Data masking."
  },
  {
    "id": 78,
    "topic_id": 1,
    "title": "What is the processes involved in the transitioning of a part or all of a company\u2019s data, applications, and services from a traditional on-premises enterprise environment to one in the cloud where information can be accessed from anywhere, anytime?",
    "description": "Cloud migration."
  },
  {
    "id": 79,
    "topic_id": 1,
    "title": "This term describes the process or act of verification of eligibility of a station, originator, or individual to access specific categories of information. It is also designed to protect against fraudulent transmissions by establishing validity of the transmission or its originator.",
    "description": "Authentication."
  },
  {
    "id": 80,
    "topic_id": 1,
    "title": "The ability for a consumer or user to be able to move their associated applications and/or data between competing cloud providers or between public and private clouds.",
    "description": "Cloud portability."
  },
  {
    "id": 81,
    "topic_id": 1,
    "title": "This type of cloud offering is provisioned for open use by the public. It can be owned, managed, or operated by any combination such as a business, academic institution, or government organization and exists on the premises of the cloud provider.",
    "description": "Public cloud."
  },
  {
    "id": 82,
    "topic_id": 1,
    "title": "One phase of the SDLC where all functional features of the system used in development are described independently of any computer platform.",
    "description": "Logical design."
  },
  {
    "id": 83,
    "topic_id": 1,
    "title": "This monitors inbound and outbound data packets from the device on which it is installed and alerts users or admins only if suspicious activity is detected.",
    "description": "Host intrusion detection systems (HIDS)."
  },
  {
    "id": 84,
    "topic_id": 1,
    "title": "This type of cloud infrastructure is provisioned for use by a single entity (organization, corporation, etc.) consisting of many consumers. It can be owned, operated, and/or managed by the organization itself, a third party, or some combination of the two and may exist either on or off premises.",
    "description": "Private cloud."
  },
  {
    "id": 85,
    "topic_id": 1,
    "title": "This subset of an ONF contains only information necessary for reaching a targeted level of trust for a specific business application.",
    "description": "Application normative framework (ANF)."
  },
  {
    "id": 86,
    "topic_id": 1,
    "title": "This process is a way of deliberately destroying the encryption keys used to originally encrypt data.",
    "description": "Crypto-shredding."
  },
  {
    "id": 87,
    "topic_id": 1,
    "title": "This term is often referred to as a device but is actually a method of analyzing risk in software systems. It involves a centralized collection and monitoring of security- and event-related logs from in-scope systems. It then provides for the correlation of different events and early detection of attacks.",
    "description": "Security information and event management (SIEM)."
  },
  {
    "id": 88,
    "topic_id": 1,
    "title": "A newer, more secure form of the original that involves a suite of extensions to add security to the DNS protocol that enables DNS responses to be validated. Specifically, it provides for origin authority, data integrity in responses, and authenticated denial of existence.",
    "description": "Domain Name System Security Extensions (DNSSEC)."
  },
  {
    "id": 89,
    "topic_id": 1,
    "title": "This method of erasure uses strong magnets for scrambling data on magnetic media such as hard drives and tape so that data is not recoverable.",
    "description": "Degaussing."
  },
  {
    "id": 90,
    "topic_id": 1,
    "title": "The rules, statutes, and body of law that define conduct that is prohibited by the government and are designed to protect the safety and well-being of the public.",
    "description": "Criminal law."
  }
];
